import useStyles from './BaseIcon.styles'

export const useBaseIcon = ({ className, component, viewBox }) => {
	const classes = useStyles()

	return [
		{
			className,
			component,
			viewBox,
			classes,
		},
	]
}
